export default class Shindouatsu {
  constructor() {
    if (!document.querySelector('.p-shindouatsu-detail')) {
      return;
    }

    this.initModal();
  }

  initModal() {
    const modalTriggers = document.querySelectorAll(
      '.p-shindouatsu-detail__media-video[data-modal]'
    );
    const modalContents = document.querySelectorAll(
      '.p-shindouatsu-detail .modal_content[data-modal]'
    );
    const modalCloseButtons = document.querySelectorAll(
      '.p-shindouatsu-detail .modal_close_button'
    );
    const modalInners = document.querySelectorAll(
      '.p-shindouatsu-detail .modal_inner'
    );
    const youtubeIframes = document.querySelectorAll(
      '.p-shindouatsu-detail .youtube'
    );

    if (!modalTriggers.length || !modalContents.length) {
      return;
    }

    let isScrollLocked = false;
    let activeTrigger = null;

    const lockScroll = () => {
      if (isScrollLocked) return;
      document.documentElement.classList.add('is-modal-open');
      document.body.classList.add('is-modal-open');
      isScrollLocked = true;
    };

    const unlockScroll = () => {
      if (!isScrollLocked) return;
      document.documentElement.classList.remove('is-modal-open');
      document.body.classList.remove('is-modal-open');
      isScrollLocked = false;
    };

    const pauseYoutube = () => {
      youtubeIframes.forEach((iframe) => {
        if (!iframe.contentWindow) return;
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":[]}',
          '*'
        );
      });
    };

    const closeModal = (keepScrollLock = false) => {
      document
        .querySelectorAll('.modal_bg.is__active')
        .forEach((bg) => bg.classList.remove('is__active'));
      document
        .querySelectorAll('.modal_inner.is__active')
        .forEach((inner) => inner.classList.remove('is__active'));
      modalContents.forEach((content) => {
        content.classList.remove('is__active');
        content.setAttribute('aria-hidden', 'true');
      });
      pauseYoutube();

      if (!keepScrollLock) {
        unlockScroll();
        activeTrigger?.querySelector('.modal_trigger')?.focus();
        activeTrigger = null;
      }
    };

    modalTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        const modalId = trigger.dataset.modal;
        if (!modalId) return;

        const targetModal = document.querySelector(
          `.p-shindouatsu-detail .modal_content[data-modal="${modalId}"]`
        );
        if (!targetModal) return;

        const modalRoot = targetModal.closest('.modal');
        if (!modalRoot) return;

        const modalBg = modalRoot.querySelector('[data-modal="bg"]');
        const modalInner = modalRoot.querySelector('[data-modal="inner"]');
        if (!modalBg || !modalInner) return;

        closeModal(true);
        activeTrigger = trigger;
        modalBg.classList.add('is__active');
        modalInner.classList.add('is__active');
        targetModal.classList.add('is__active');
        targetModal.setAttribute('aria-hidden', 'false');
        lockScroll();
        targetModal.querySelector('.modal_close_button')?.focus();
      });
    });

    modalInners.forEach((inner) => {
      inner.addEventListener('click', (event) => {
        if (event.target === inner) {
          closeModal();
        }
      });
    });

    modalCloseButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isScrollLocked) {
        closeModal();
      }
    });
  }
}
